import { HeartFilled, StarFilled, UserOutlined } from '@ant-design/icons';
import { cn } from 'lib/utils';
import { CSSProperties } from 'react';
import { AccessTier } from 'services/api/models/UserDTO';

const PATIENT_ACCESS_TIER_CONFIG = {
  LICENSE_CODE: {
    Icon: StarFilled,
    colorClassName: 'text-tier-license',
  },
  APP_SUBSCRIPTION: {
    Icon: HeartFilled,
    colorClassName: 'text-tier-subscription',
  },
  FREE: {
    Icon: UserOutlined,
    colorClassName: 'text-tier-free',
  },
} as const satisfies Record<AccessTier, { Icon: typeof StarFilled; colorClassName: string }>;

type PatientAccessTierIconProps = {
  accessTier: AccessTier;
  className?: string;
  style?: CSSProperties;
};

export default function PatientAccessTierIcon({ accessTier, className, style }: PatientAccessTierIconProps) {
  const { Icon, colorClassName } = PATIENT_ACCESS_TIER_CONFIG[accessTier];
  return <Icon className={cn(colorClassName, className)} style={style} />;
}
